import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  effect,
  input,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { WarehouseProductDataSourceService } from '../../services/warehouse-product-data-source.service';
import { isEmptyString, isNil, Nillable, valueOrDefault } from '@web/utils';
import { Observable, of } from 'rxjs';
import { WarehouseSkuUsage } from '../../models/warehouse-sku-usage';
import { WarehouseSkuUsageStatus } from '../../enums/warehouse-sku-usage-status';

@Component({
  selector: 'app-warehouse-sku-usage-status',
  imports: [CommonModule],
  templateUrl: './warehouse-sku-usage-status.component.html',
  styleUrl: './warehouse-sku-usage-status.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WarehouseSkuUsageStatusComponent {
  private readonly changeDetectorRef = inject(ChangeDetectorRef);
  /* prettier-ignore */
  private readonly warehouseProductDataSource = inject(WarehouseProductDataSourceService);

  public readonly sku = input<Nillable<string>>();

  protected readonly WarehouseSkuUsageStatus = WarehouseSkuUsageStatus;
  protected readonly valueOrDefault = valueOrDefault;

  protected usage$!: Observable<Nillable<WarehouseSkuUsage>>;

  public constructor() {
    effect(() => this.configureUsage());
  }

  private configureUsage(): void {
    const sku = this.sku();

    this.usage$ = this.usageSource(sku);
    this.changeDetectorRef.detectChanges();
  }

  private usageSource(
    sku: Nillable<string>,
  ): Observable<Nillable<WarehouseSkuUsage>> {
    if (isNil(sku)) {
      return of(null);
    }

    if (isEmptyString(sku)) {
      return of(null);
    }

    return this.warehouseProductDataSource.fetchSkuUsage(sku);
  }
}
